import { DXP_REGISTRATION_ROUTE } from "./constants";
import { prepareDxpImsRedirectStorage } from "./dxpAdobeImsAuth";
import {
  isDxpInvitedContactRegistration,
  markDxpPartnerResumePendingAfterIms,
  persistDxpRegistrationResumeFromPartnerApi,
  prepareDxpInvitedContactWizardState,
  shouldResumeDxpRegistrationAtCompanyStep,
} from "./hydratePartnerRegistrationSession";

type ContinueRegistrationDeps = {
  getUserData: () => { email?: string } | null | undefined;
  getDXPRegistrationLink: () => string;
};

/** Handles "Complete registration now" / continue-registration navigation and IMS sign-in. */
export function runDxpContinueRegistration(
  deps: ContinueRegistrationDeps,
): void {
  prepareDxpImsRedirectStorage();
  localStorage.setItem("RedirectPath", DXP_REGISTRATION_ROUTE);
  localStorage.removeItem("emailMismatch");

  const redirectTo = localStorage.getItem("redirectTo");
  const partnerId = localStorage.getItem("accountId");
  const shouldResumeAtCompany = shouldResumeDxpRegistrationAtCompanyStep();

  const finishContinueRegistration = () => {
    if (!shouldResumeAtCompany) {
      if (isDxpInvitedContactRegistration()) {
        prepareDxpInvitedContactWizardState();
      } else if (redirectTo && redirectTo !== "membershipdetails") {
        localStorage.removeItem("partnerRegistrationFormStep");
      } else {
        const rawStep = localStorage.getItem("partnerRegistrationFormStep");
        const parsedStep = rawStep ? parseInt(rawStep, 10) : 0;
        const savedStep = Number.isNaN(parsedStep) ? 0 : parsedStep;
        // Do not downgrade a saved company step (e.g. after save-and-exit) to user profile.
        if (savedStep < 4) {
          localStorage.setItem("partnerRegistrationFormStep", "3");
        }
      }
    }
    const userData = deps.getUserData();
    const email = userData?.email || "";
    if (email) localStorage.setItem("email", email);
    if (window.adobeIMS?.isSignedInUser?.()) {
      window.open(deps.getDXPRegistrationLink(), "_self");
    } else {
      window.adobeIMS?.signIn();
    }
  };

  if (shouldResumeAtCompany && partnerId) {
    if (window.adobeIMS?.isSignedInUser?.()) {
      persistDxpRegistrationResumeFromPartnerApi(partnerId)
        .then((ok) => {
          if (!ok) {
            localStorage.setItem("partnerRegistrationFormStep", "3");
          }
          finishContinueRegistration();
        })
        .catch(() => {
          localStorage.setItem("partnerRegistrationFormStep", "3");
          finishContinueRegistration();
        });
    } else {
      // Partner GET requires IMS token — hydrate after redirect in RegistrationWizardWrapper.
      markDxpPartnerResumePendingAfterIms(partnerId);
      finishContinueRegistration();
    }
  } else {
    finishContinueRegistration();
  }
}
